// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eventselecttypeControl {
  font-size: 11px !important;
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100% !important;
  line-height: 30px !important;
  height: 30px !important;
  border-radius: 5px !important;
  padding-left: 5px !important;
  position: relative;
  border-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border: none;
}

.dot-red {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}

.dot-green {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: green;
}

i.disable {
  position: absolute;
  cursor: not-allowed !important;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: transparent;
}

.mapcard {
  height: 27px;
  margin-bottom: 5px;
}

.ellips {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.previewlist {
  /*float: left;*/
  max-width: 14%;
  padding: 0.75rem;
  margin-bottom: 1%;
  margin-inline: 2px;
  border: 0;
  flex-basis: 33.333%;
  flex-grow: 0;
  flex-shrink: 0;
}

.previewlist > img {
  margin-bottom: 0.75rem;
  width: 100%;
}

.parentcontainer {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.ellipshistory {
  display: block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
}

::ng-deep.preview_template .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 25%;
}

.highlight_text:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb !important;
  padding-inline: 3%;
  padding-block: 1px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

::ng-deep .showtooltipjob {
  white-space: pre-line !important;
  align-items: center !important;
}

.label {
  font-size: 85% !important;
}

.paramertes_iniheight {
  height: 500px;
  overflow: auto;
  overflow-x: hidden;
}

.copyicon_pn {
  font-size: 18px;
  cursor: pointer;
}

::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/patienthistory/patienthistory.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACA,0BAAA;EACI,iCAAA;EACA,qCAAA;EACA,sBAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,oDAAA;EACA,YAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;AADJ;;AAGE;EACE,kBAAA;EACA,8BAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;AAAJ;;AAEE;EAEE,YAAA;EACA,kBAAA;AAAJ;;AAEE;EAEA,mBAAA;EAAoB,gBAAA;EAAiB,uBAAA;AAEvC;;AAKE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAFJ;;AAKE;EACE,sBAAA;EACA,WAAA;AAFJ;;AAQE;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AALJ;;AAOE;EAEE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,yCAAA;AALJ;;AAQE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,QAAA;AALJ;;AAQE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AALJ;;AAQE;EAEE,gCAAA;EACA,8BAAA;AANJ;;AAQE;EAEE,yBAAA;AANJ;;AASE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AANJ;;AAQE;EAEA,eAAA;EACA,eAAA;AANF;;AASE;EACE,WAAA;EACA,YAAA;AANJ;AAOI;EACE,gCChJM;EDiJN,oCCjJM;AD4IZ;AAOI;EACE,YAAA;AALN;AAQE;EACE,uBAAA;EACA,sBAAA;AANJ","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.eventselecttypeControl{\r\nfont-size: 11px !important;\r\n    background-color: #fff !important;\r\n    color: rgba(0, 0, 0, 0.87) !important;\r\n    width: 100% !important;\r\n    line-height: 30px !important;\r\n    height: 30px !important;\r\n    border-radius: 5px !important;\r\n    padding-left: 5px !important;\r\n    position: relative;\r\n    border-color: #fff;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    border: none;\r\n}\r\n\r\n.dot-red {\r\n    height: 10px;\r\n    width: 10px;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    background-color: red;\r\n  }\r\n\r\n.dot-green {\r\n    height: 10px;\r\n    width: 10px;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    background-color: green;\r\n  }\r\n  i.disable{\r\n    position: absolute;\r\n    cursor: not-allowed !important;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    color: transparent;\r\n  }\r\n  .mapcard\r\n  {\r\n    height: 27px;\r\n    margin-bottom: 5px;\r\n  }\r\n  .ellips\r\n  {\r\n  white-space: nowrap;overflow: hidden;text-overflow: ellipsis;\r\n  }\r\n  // .previewlist\r\n  // {\r\n  //   width: 100px;height: 214px;float: left;\r\n  // }\r\n\r\n  .previewlist {\r\n    /*float: left;*/\r\n    max-width: 14%;\r\n    padding: .75rem;\r\n    margin-bottom: 1%;\r\n    margin-inline: 2px;\r\n    border: 0;\r\n    flex-basis: 33.333%;\r\n    flex-grow: 0;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .previewlist > img {\r\n    margin-bottom: .75rem;\r\n    width: 100%;\r\n  }\r\n\r\n  // .card-text {\r\n  //   font-size: 85%;\r\n  // }\r\n  .parentcontainer{\r\n    align-items: stretch;\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: nowrap;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n  }\r\n  .ellipshistory\r\n  {\r\n    display: block;\r\n    white-space: nowrap;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    font-size: 12px;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n  }\r\n\r\n  ::ng-deep.preview_template .modal-dialog {\r\n    max-width: 97%!important;\r\n    max-height: 60%!important;\r\n    height: 60%!important;\r\n    margin: auto!important;\r\n    padding: 0 !important;\r\n    top: 25%;\r\n  }\r\n\r\n  .highlight_text:hover{\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 90% !important;\r\n    display: inline-block;\r\n    background-color: #3fa4fb !important;\r\n    padding-inline: 3%;\r\n    padding-block: 1px;\r\n    border-radius: 12px;\r\n    color: white !important;\r\n    cursor: pointer;\r\n  }\r\n\r\n  ::ng-deep .showtooltipjob\r\n  {\r\n    white-space: pre-line !important;\r\n    align-items: center !important;\r\n  }\r\n  .label\r\n  {\r\n    font-size: 85% !important;\r\n  }\r\n\r\n  .paramertes_iniheight {\r\n    height: 500px;\r\n    overflow: auto;\r\n    overflow-x: hidden;\r\n  }\r\n  .copyicon_pn\r\n{\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n}\r\n::ng-deep.msgreplist.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
